export const utm_query_params = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_id",
    "utm_term",
  ];